var map = {
	"./federal/dark/rancher-logo.svg": 1954,
	"./federal/metadata": 850,
	"./federal/metadata.json": 850,
	"./federal/rancher-logo.svg": 1955,
	"./rgs/dark/rancher-logo.svg": 1956,
	"./rgs/metadata": 851,
	"./rgs/metadata.json": 851,
	"./rgs/rancher-logo.svg": 1957,
	"./suse/dark/rancher-logo.svg": 1958,
	"./suse/metadata": 852,
	"./suse/metadata.json": 852,
	"./suse/rancher-logo.svg": 1959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1205;